import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import _ from 'lodash';
import Table from '../../../../../components/LazyWidgets/Table';
import MiniTable from '../../../../../components/LazyWidgets/MiniTable';
import EmailWithTooltip from '../../../../components/EmailTooltip/EmailWithTooltip';
import s from '../skillsReflectionSummary.module.css';
import { getQuestionReponseColumn } from './componentFunctions';

class SkillsReflectionTable extends Component {
  static propTypes = {
    displayedStudentList: PropTypes.array,
    tableStyle: PropTypes.array,
    collapse: PropTypes.bool,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const newData = {};
    const order = {
      column: prevState.defaultOrder.sortBy,
      direction: prevState.defaultOrder.direction,
    };

    if (prevState.displayedStudentList !== nextProps.displayedStudentList) {
      newData.displayedStudentList = SkillsReflectionTable.listToShow(
        nextProps.displayedStudentList,
        nextProps.collapse,
        order
      );
      newData.sortBy = prevState.defaultOrder.sortBy;
      newData.direction = prevState.defaultOrder.direction;
    }
    if (prevState.collapse !== nextProps.collapse) {
      newData.displayedStudentList = SkillsReflectionTable.listToShow(
        nextProps.displayedStudentList,
        nextProps.collapse,
        order
      );
      newData.collapse = nextProps.collapse;
    }
    return !_.isEmpty(newData) ? newData : null;
  }

  static listToShow(students, collapse, order) {
    const hasAgree = students
      ? _.filter(
          students,
          (student) => student.questionResponseSortingValue > 3
        )
      : [];

    if (hasAgree.length === 0 && students.length > 0 && collapse) {
      return _.orderBy(
        SkillsReflectionTable.styleData(students),
        [order.column],
        [order.direction]
      ).slice(0, 5);
    }
    if (collapse) {
      return _.orderBy(
        _.filter(
          SkillsReflectionTable.styleData(students),
          (o) => o.questionResponseSortingValue > 3
        ),
        [order.column],
        [order.direction]
      );
    }

    if (!collapse) {
      return _.orderBy(
        SkillsReflectionTable.styleData(students),
        [order.column],
        [order.direction]
      );
    }
    return _.orderBy(
      SkillsReflectionTable.styleData(students),
      [order.column],
      [order.direction]
    );
  }

  static styleData(tData) {
    return tData.map((item) => {
      item.className =
        item.questionResponseSortingValue === 5 ? 'styledRow' : 'zeroStyle';
      return item;
    });
  }

  constructor(props) {
    super(props);
    this.tableSort = this.tableSort.bind(this);
    const defaultOrder = {
      sortBy: 'questionResponseSortingValue',
      direction: 'desc',
    };
    const order = {
      column: defaultOrder.sortBy,
      direction: defaultOrder.direction,
    };
    this.state = {
      defaultOrder,
      collapse: this.props.collapse,
      displayedStudentList: SkillsReflectionTable.listToShow(
        props.displayedStudentList,
        props.collapse,
        order
      ),
      sortBy: defaultOrder.sortBy,
      direction: defaultOrder.direction,
    };
  }

  tableSort(_e, order) {
    const direction = order.direction;
    const newTable = _.orderBy(
      this.state.displayedStudentList,
      [order.column, 'name'],
      [direction]
    );
    this.setState({
      sortBy: order.column,
      direction: order.direction,
      displayedStudentList: newTable,
    });
  }

  render() {
    const columns = [
      {
        accessor: 'name',
        Header: 'Name',
        cell: (item) => (
          <div>
            <span>{item.name}</span>
            <br />
            <EmailWithTooltip email={item.email} />
          </div>
        ),
      },
      {
        accessor: 'questionResponseSortingValue',
        Header: 'Response',
        cell: (item) => getQuestionReponseColumn(item.answer),
      },
    ];

    const { displayedStudentList } = this.state;

    return (
      <Media query={{ minWidth: 710 }}>
        {(matches) =>
          matches ? (
            <Table
              className={s.tableCard}
              data={displayedStudentList}
              styling={this.props.tableStyle}
              columns={columns}
              sortable
              ruled
              autosort={false}
              onSortedChange={this.tableSort}
              sortColumn={this.state.sortBy}
              sortDirection={this.state.direction}
              minWidth={555}
            />
          ) : (
            <MiniTable
              className={s.minitable}
              data={displayedStudentList}
              columns={columns}
              styling={this.props.tableStyle}
              sortable
              ruled
              autosort={false}
              onSortedChange={this.tableSort}
              sortColumn={this.state.sortBy}
              sortDirection={this.state.direction}
              minWidth={220}
            />
          )
        }
      </Media>
    );
  }
}

export default SkillsReflectionTable;
